<template>
  <div >
    <div class="row mb-3">
      <div class="col d-3 sm-11" v-for="item in items">
        <ASelect
          static-label
          label=" "
          v-if="item.type==='select'"
          display="title"
          @change="setFilter"
          :emptyOptions="params.messages.emptyOptions"
          :placeholder="item.title"
          :options="item.options"
          v-model="item.value"
        >
          <template #item="{title}">{{ title }}</template>
        </ASelect>
        <a-date-picker
            v-else-if="item.type=='datePicker'"
            static-label
            label=" "
            @update:modelValue="setFilter"
            range
            :placeholder="item.title"
            v-model="item.value"
        />


      </div>
      <div class="col view-mode" :class="'d-'+ViewModeW">
        <slot name="footer"></slot>
      </div>
    </div>
    <div class="row">
      <div class="col d12 selectedFilters" v-if="selected.length>0">
        <ABadge v-for="item in selected" @click="removeItem(item)">
            {{item.title}}
          <svg class="cancelBtn" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg>
        </ABadge>
      </div>
    </div>
  </div>
</template>

<script>
import {ABtn,AChip, ABadge, ASelect, ADatePicker, useAProgressBar} from '~/components/ui'
import {ref, computed, watch, onUpdated} from 'vue'
import {send} from "../../services/api";
export default {
  name: "TaskFilter",
  props: ['params'],
  components: {
    ABtn, ABadge, ASelect, ADatePicker,AChip
  },
  setup: (props, ctx) => {
      const tmp = ref("");
      console.log(props.params.items);
    const items = ref(props.params.items);
    const selected = computed(() => {
      let Selected = [];
      for(let index in props.params.items) {
        if(JSON.stringify(props.params.items[index])!==undefined) {
          let tmpVal = JSON.parse(JSON.stringify(props.params.items[index]));
          if(tmpVal.bajeValue) {
            tmpVal.value.title = tmpVal.bajeValue;
            Selected.push(tmpVal.value);
          } else if(tmpVal.value?.title) {
            Selected.push(tmpVal.value);
          }
        }

      }
      return Selected
    });
    const ViewModeW = computed(() => {
      let w=12;
      if(items.value.length<=4) {
        w = w-(items.value.length*3);
      }

      return w;
    });
    const progress = useAProgressBar();
    const sendRequest = async () => {
      let formData = {};
      for(let index in props.params.hidden) {
        if(typeof props.params.hidden[index]=='object') {
          formData[props.params.hidden[index].name] = props.params.hidden[index].value;
        }
      }
      for(let index in items.value) {

        if(typeof items.value[index]=='object') {

          if(items.value[index].type === 'datePicker') {
            for(let optionIndex in items.value[index].options) {
              let v = '';
              if(items.value[index].value[items.value[index].options[optionIndex].visual]) {
                v = items.value[index].value[items.value[index].options[optionIndex].visual];
              }
              formData[items.value[index].options[optionIndex].id] = v;
            }
          } else {
            if(typeof items.value[index].value.value=='object') {
              formData[items.value[index].value.id] = items.value[index].value.value.value;
            } else {
              formData[items.value[index].value.id] = items.value[index].value.value;
            }
          }
        }
      }
      await send(props.params.form.action, {method: props.params.form.method}, formData).then((response) => {
        if(typeof response == 'string') {
          //response = response.replace(/\r?\n/g, "");
          var re = /'/gi;
          response = response.replace(re, '"');
          response = JSON.parse(response);
        }
        ctx.emit('change', {url:response.FILTER_URL,count:response.ELEMENT_COUNT});
      })
    };
    let timeout = false;

    const removeItem = (item) => {
      for(let index in items.value) {
        if(items.value[index]?.value?.id==item.id) {
          items.value[index].value=[];
        }
      }
      sendRequest();
    };
    const setFilter = (e) => {
        console.log(tmp.value,e.start);
        if(e.id!=undefined||(e.start!=undefined&&tmp.value!=e.start)) {
            if(timeout!=false) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() =>{
                sendRequest();
            },800);
            if(e.start!=undefined) {
                tmp.value = e.start;
            }

        }
    };


    onUpdated(()=>{
        //alert();
        items.value = props.params.items;
    })

    return {
      items,
      removeItem,
      selected,
      ViewModeW,
      setFilter
    }
  }
}
</script>

<style lang="scss" scoped>
.cancelBtn {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

</style>